import { StateProgress } from './type'

export const state_progress: StateProgress = {
    children: '',
    open: false
}
